'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'umbrella-beach';
var width = 512;
var height = 512;
var aliases = [127958];
var unicode = 'f5ca';
var svgPathData = 'M512 256c0 41.2-9.7 80.1-27 114.5l-206.8-103.4-1.6 3.2-88.8 177.7 324.2 0 0 64-512 0 0-64 116.2 0 103.2-206.3 1.6-3.2-194-97C69 57.6 155.8 0 256 0 397.4 0 512 114.6 512 256z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUmbrellaBeach = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;